import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";

class UnitCreateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const propertyId = parseInt(this.component.props.params.propertyId, 10);
    this.component.selectedProperty = this.component.props.properties.byId[propertyId];
		const usingBeta = this.component.props && this.component.props.app && this.component.props.app.settings && this.component.props.app.settings.user && this.component.props.app.settings.user.beta;
    
    this.component.props.dispatch({
      type: Constants.GLOBAL_UNIT_CREATE_CLEAR
    });

    if (propertyId && propertyId !== 0) {
			this.component.autoSelectPropertyId = propertyId;
      this.component.disablePropertyId = propertyId;
		}

    this.component.setState({
      beta: usingBeta
    });

    if (Object.keys(this.component.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdProperty = this.component.props.app.savedDataBeforeRedirecting.createdProperty &&
        this.component.props.app.savedDataBeforeRedirecting.createdProperty;

      if (typeof createdProperty !== "undefined") {
        this.component.selectedProperty = createdProperty;
      }

      this.component.setState({...this.component.props.app.savedDataBeforeRedirecting.unitCreateDataToBeSaved}, () => {
        this.component.props.dispatch({
          type: Constants.PROPERTY_SAVED_DATA_BEFORE_REDIRECTING_CLEAR
        });
      });
    }
  }
}

export default new UnitCreateWillMount();
